export const awsBlock = 0.1000;
export const awsCompute = 0.096;
export const awsEgress1 = 0.0900;
export const awsEgress2 = 0.0850;
export const awsEgress3 = 0.0700;
export const awsEgress4 = 0.0500;
export const awsGpu = 3.06;
export const awsIops = 0.0650;
export const ociBlock = 0.0255;
export const ociCompute = 0.0490;
export const ociEgress = 0.0085;
export const ociGpu = 2.950;
export const awsVpu = 0;
export const ociVpu = 0.0017;
export const ociCpu = 0.0490;
export const awsHighBlock = 0.125;
